import React, { useState } from 'react';
import { FaShoppingBasket, FaStore, FaEnvelope, FaUser, FaPhone } from 'react-icons/fa';

export default function WelcomePage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !contact || !message) {
      alert('Please fill in all fields.');
      return;
    }
    setSubmitting(true);
    // Simulate successful API submission
    setTimeout(() => {
      setSubmitting(false);
      setName('');
      setContact('');
      setMessage('');
      setShowModal(false);
      alert('Your message has been sent successfully. We will get back to you soon!');
    }, 1200);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#ffffff',
      fontFamily: "'Outfit', 'Inter', sans-serif",
      padding: '40px 24px',
      color: '#334155',
    }}>
      {/* Container */}
      <div style={{
        maxWidth: '520px',
        width: '100%',
        textAlign: 'center',
        padding: '24px 16px',
      }}>
        
        {/* 1. Logo on top */}
        <img 
          src={process.env.PUBLIC_URL + '/bestlogo.png'} 
          alt="Best Basket Logo" 
          style={{
            width: '240px',
            height: 'auto',
            marginBottom: '24px',
            objectFit: 'contain'
          }}
        />


        {/* 3. Welcome Message (1 or 2 lines) */}
        <p style={{
          fontSize: '17px',
          lineHeight: '1.6',
          color: '#64748b',
          margin: '0 auto 32px auto',
          maxWidth: '440px',
          fontWeight: '500'
        }}>
          Welcome to Best Basket! Download our Play Store App to buy groceries on exciting offers.
        </p>

        {/* 4. Action buttons / links */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {/* Link 1: Play Store */}
          <a 
            href="https://play.google.com/store/apps/details?id=com.salmanres.BestBasket"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              backgroundColor: '#ffd600',
              borderRadius: '12px',
              padding: '14px 28px',
              color: '#1a237e',
              fontWeight: '700',
              fontSize: '15px',
              textDecoration: 'none',
              boxShadow: '0 4px 12px rgba(255, 214, 0, 0.2)',
              cursor: 'pointer',
              flex: '1',
              minWidth: '200px',
              border: '2px solid #ffd600'
            }}
          >
            <FaStore size={18} />
            <span>Download App</span>
          </a>

          {/* Link 2: Contact Us Button */}
          <button 
            onClick={() => setShowModal(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: '14px 28px',
              color: '#1a237e',
              fontWeight: '700',
              fontSize: '15px',
              border: '2px solid #1a237e',
              cursor: 'pointer',
              flex: '1',
              minWidth: '200px',
              boxShadow: '0 4px 12px rgba(26, 35, 126, 0.05)',
              outline: 'none'
            }}
          >
            <FaEnvelope size={16} />
            <span>Contact Us</span>
          </button>
        </div>

        {/* Contact Us Modal */}
        {showModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}>
            <div style={{
              backgroundColor: '#ffffff',
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              padding: '32px 28px',
              maxWidth: '480px',
              width: '100%',
              position: 'relative',
              textAlign: 'left',
              boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)',
              animation: 'scaleUp 0.25s ease-out'
            }}>
              {/* Close Icon button */}
              <button 
                onClick={() => setShowModal(false)}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#94a3b8',
                  outline: 'none',
                  lineHeight: 1
                }}
              >
                &times;
              </button>

              <h3 style={{
                fontSize: '20px',
                fontWeight: '700',
                color: '#1a237e',
                marginBottom: '6px',
                marginTop: 0
              }}>
                Contact Us
              </h3>
              <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 20px 0' }}>
                Leave a message and we'll support you immediately.
              </p>

              <form onSubmit={handleSubmit}>
                {/* Name field */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px', display: 'block' }}>
                    Full Name
                  </label>
                  <div style={{ position: 'relative' }}>
                    <FaUser style={{ position: 'absolute', left: '14px', top: '15px', color: '#94a3b8' }} />
                    <input 
                      type="text"
                      placeholder="Enter your name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 16px 12px 40px',
                        borderRadius: '8px',
                        border: '1px solid #cbd5e1',
                        fontSize: '14px',
                        color: '#1e293b',
                        outline: 'none',
                        backgroundColor: '#ffffff'
                      }}
                      required
                    />
                  </div>
                </div>

                {/* Email / Phone field */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px', display: 'block' }}>
                    Email or Phone Number
                  </label>
                  <div style={{ position: 'relative' }}>
                    <FaPhone style={{ position: 'absolute', left: '14px', top: '15px', color: '#94a3b8' }} />
                    <input 
                      type="text"
                      placeholder="Email or phone number"
                      value={contact}
                      onChange={(e) => setContact(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 16px 12px 40px',
                        borderRadius: '8px',
                        border: '1px solid #cbd5e1',
                        fontSize: '14px',
                        color: '#1e293b',
                        outline: 'none',
                        backgroundColor: '#ffffff'
                      }}
                      required
                    />
                  </div>
                </div>

                {/* Message field */}
                <div style={{ marginBottom: '24px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px', display: 'block' }}>
                    Message
                  </label>
                  <textarea 
                    placeholder="How can we help you?"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows="4"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #cbd5e1',
                      fontSize: '14px',
                      color: '#1e293b',
                      outline: 'none',
                      resize: 'none',
                      backgroundColor: '#ffffff'
                    }}
                    required
                  />
                </div>

                {/* Submit button */}
                <button 
                  type="submit"
                  disabled={submitting}
                  style={{
                    width: '100%',
                    padding: '14px',
                    backgroundColor: '#1a237e',
                    color: '#ffffff',
                    fontWeight: '700',
                    fontSize: '14px',
                    borderRadius: '10px',
                    border: 'none',
                    cursor: submitting ? 'not-allowed' : 'pointer',
                    boxShadow: '0 4px 12px rgba(26, 35, 126, 0.2)',
                    opacity: submitting ? 0.8 : 1,
                    outline: 'none'
                  }}
                >
                  {submitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>

      {/* Embedded CSS for animation */}
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes scaleUp {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}} />
    </div>
  );
}
